import Password from '@/api/password'
import loading from '../helpers/loading'

export default {
  namespaced: true,
  state: loading.state,
  getters: loading.getters,
  mutations: loading.mutations,
  actions: {
    sendEmail: ({ commit, dispatch }, { email, platformName }) => {
      commit('changeLoading', { isLoading: true })
      return Password.sendEmail({ email, platformName })
        .then(({ data }) => {
          commit('changeLoading', { isLoading: false })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    },
    reset: ({ commit, dispatch }, { token, password, passwordConfirmation, platformName }) => {
      commit('changeLoading', { isLoading: true })
      return Password.reset({ token, password, passwordConfirmation, platformName })
        .then(({ data }) => {
          commit('changeLoading', { isLoading: false })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/password/index.js